////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const languagesManager = {
	[ActionsTypes.GET_LANGUAGES]: (state) =>
		update(state, {
			languagesManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
				/* paging: {
					$set: {}
				} */
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_LANGUAGES_SUCCESS]: (state, payload) => {
		let items = cloneDeep(payload.data.headerContent.contentPagined.content)
		let paging = cloneDeep(payload.data.headerContent.contentPagined)

		return update(state, {
			languagesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: items,
				},
				paging: {
					$set: paging,
				},
			},
		})
	},
	[ActionsTypes.GET_LANGUAGES_FAILURE]: (state, payload) =>
		update(state, {
			languagesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_LANGUAGE_ENABLING]: (state) =>
		update(state, {
			languagesManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_LANGUAGE_ENABLING_SUCCESS]: (state, payload) => {
		let oldLanguages = cloneDeep(state.languagesManager.items)
		const idxLanguage = findIndex(oldLanguages, { id: payload.data.body.id })
		oldLanguages[idxLanguage] = payload.data.body

		return update(state, {
			languagesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: oldLanguages,
				},
			},
		})
	},
	[ActionsTypes.PUT_LANGUAGE_ENABLING_FAILURE]: (state, payload) =>
		update(state, {
			languagesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_LANGUAGES_MANAGER]: (state, _payload) => {
		return update(state, {
			languagesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
				paging: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.GET_LANGUAGE_DETAIL]: (state) =>
		update(state, {
			languageDetail: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_LANGUAGE_DETAIL_SUCCESS]: (state, payload) => {
		return update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_LANGUAGE_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_CREATE_LANGUAGE_DETAIL]: (state) =>
		update(state, {
			languageDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_CREATE_LANGUAGE_DETAIL_SUCCESS]: (state, payload) => {
		return update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_CREATE_LANGUAGE_DETAIL_FAILURE]: (state, payload) => {
		return update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL]: (state, _payload) => {
		return update(state, {
			languageDetail: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL_SUCCESS]: (state, payload) => {
		return update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			languageDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_LANGUAGE_DETAIL]: (state) =>
		update(state, {
			languageDetail: {
				items: {
					$set: false,
				},
				paging: {
					$set: {},
				},
			},
		}),
}

export default languagesManager
